import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="mx-auto flex max-w-md flex-col items-center px-4 py-20 text-center" data-testid="payment-cancel-page">
      <XCircle className="h-14 w-14 text-red-500" />
      <h1 className="mt-4 font-heading text-2xl font-bold">{t("payment.cancelTitle")}</h1>
      <p className="mt-2 text-muted-foreground">{t("payment.cancelBody")}</p>
      <Button className="mt-6 rounded-full bg-brand text-white hover:bg-brand/90" onClick={() => navigate("/lab")} data-testid="payment-cancel-continue">
        {t("payment.backToDashboard")}
      </Button>
    </div>
  );
}
